<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Content from '@/services/Content'
    import Customers from '@/services/Customers'
    import General from '@/services/General'
    import modalReactions from '@/components/modals/news/modalReactions'
    import modalAddNews from "@/components/modals/news/modalAddNews.vue";
    import modalEditNews from "@/components/modals/news/modalEditNews.vue";
    import Swal from "sweetalert2";


    export default {
        components: { Layout, PageHeader, modalReactions,modalAddNews,modalEditNews },
        page: {
            title: "News Feed",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
      watch: {
        selectedLang(newLang) {
          this.getNews(newLang);
        },
        currentPage() {
          this.ensureReactionTotalsForVisibleRows();
        },
        perPage() {
          this.ensureReactionTotalsForVisibleRows();
        },
        filter() {
          this.ensureReactionTotalsForVisibleRows();
        },
      },
        data() {
            return {
                title: "News Feed",
                items: [
                    {
                        text: "News",
                    },
                    {
                        text: "News Feed",
                        active: true,
                        href: "/news/feed",
                    },
                ],
                showRefresh:true,
                showAlert: false,
                isBusyButton: false,
                isBusy: false,
                error: null,
                showModal:false,
                modalData:{},
                link_id:null,
                newsLanguage:[],
                selectedLang:'',
                tableData: [],
                totalRows: 0,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "pdate_formatted",
                sortDesc: true,
                fields: [
                    {
                        key: "title",
                        label: "Title",
                        sortable: true,
                    },
                    {
                        key: "content_source",
                        label: "Provider",
                        sortable: true,
                    },
                    {
                        key: "lang",
                        label: "Language",
                        sortable: true,
                    },
                    {
                        key: "link",
                        label: "Link",
                        sortable: false,
                    },
                    {
                        key: "image",
                        label: "Image",
                        sortable: false,
                    },
                    {
                        key: "reactions",
                        label: "Reactions",
                        sortable: false,
                    },
                    {
                        key: "audience",
                        label: "Audience",
                        sortable: false,
                    },
                    {
                        key: "audience_group_id",
                        label: "Audience Group",
                        sortable: false,
                    },
                    {
                        key: "pdate_formatted",
                        label: "Published Date",
                        sortable: true,
                    },
                    "action",
                ],
                filteredItems: null,
                reactionTotals: {}, // { [contentId]: number }
                reactionTotalsLoading: {}, // { [contentId]: boolean }
                groupsById: {},
                refreshNewsBtn:false,
                addNewsButton:false,
                selectedNewsItem: {},
            };
        },
        async created() {
            await this.getGroups();
            await this.getNews();
            await this.getNewsLanguage();
            this.refreshNewsBtn = await this.checkObjectAccessCall('button.news.refresh');
            this.addNewsButton = await this.checkObjectAccessCall('button.news.add');
        },
      methods: {
        async getGroups() {
          try {
            const response = await Customers.getGroups();
            const rows = response.data.data ? response.data.data : [];
            const groupsById = {};
            rows.forEach((group) => {
              if (group && group.group_id) {
                groupsById[String(group.group_id)] = group.name || String(group.group_id);
              }
            });
            this.groupsById = groupsById;
          } catch (error) {
            this.groupsById = {};
          }
        },
        getAudienceGroupName(groupId) {
          if (!groupId) {
            return '—';
          }
          return this.groupsById[String(groupId)] || String(groupId);
        },
        // After create/edit: refresh once using the language from the modal (sync toolbar select).
        onRefreshScreen(lang) {
          if (lang && this.selectedLang !== lang) {
            this.selectedLang = lang;
            return;
          }
          this.getNews(lang || this.selectedLang);
        },
        modalAddNews() {
          this.$bvModal.show("add_news");
        },
        modalEditNews(item) {
          this.selectedNewsItem = { ...item };
          this.$nextTick(() => {
            this.$bvModal.show("edit_news");
          });
        },
            async getNews(language){
                try {
                  const params = '1000';
                    this.toggleBusy();
                    const response = await Content.getNews(params, language,1,1)
                    this.tableData = response.data.news
                    this.totalRows = this.tableData.length
                    this.toggleBusy();
                    this.$nextTick(() => this.ensureReactionTotalsForVisibleRows());
                } catch (error) {
                    this.toggleBusy();
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                }
            },
          async getNewsLanguage(){
            try {
              this.toggleBusy();
              const response = await Content.getNewsLanguage()
              this.newsLanguage = Array.isArray(response.data) ? response.data : [];
              this.toggleBusy();
            } catch (error) {
              this.toggleBusy();
              this.error = error.response.data.error ? error.response.data.error : "";
              this.newsLanguage = [];
            }
          },

            removeNews(id){
                Swal.fire({
                    title: "Remove news article?",
                    text: "This news article will be removed!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Remove!",
                }).then((result) => {
                    if (result.value) {
                        try {
                            Content.removeNews(id)
                                .then((response) => {
                                    const res = response.data ? response.data : false;
                                    const error = response.data.error ? response.data.error : 'Failed';
                                    if(res){
                                        this.getNews(this.selectedLang)
                                        Swal.fire("Remove news", "News article is successfully removed!", "success");
                                    }else{
                                        Swal.fire("Fail!", error, "warning");
                                    }
                                })
                        }catch(error){
                            this.error = error.response.data.error ? error.response.data.error : "";
                        }
                    }
                });
            },
                restoreNews(id){
                  Swal.fire({
                    title: "Restore news article?",
                    text: "This news article will be restored!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Restore!",
                  }).then((result) => {
                    if (result.value) {
                      try {
                        Content.restoreNews(id)
                            .then((response) => {
                              const res = response.data ? response.data : false;
                              const error = response.data.error ? response.data.error : 'Failed';
                              if(res){
                                this.getNews(this.selectedLang)
                                Swal.fire("Restore news", "News article is successfully restored!", "success");
                              }else{
                                Swal.fire("Fail!", error, "warning");
                              }
                            })
                      }catch(error){
                        this.error = error.response.data.error ? error.response.data.error : "";
                      }
                    }
                  });
                },

     async refreshNews() {
  try {
    this.isBusyButton = true;
                    const response = await Content.fireEvent({event_type: 'refresh_news'});
                    if(response.data.data == 'refreshed') {
                         this.showRefresh = false;
                         this.showAlert = true;
                           setTimeout(() => {
                               this.showAlert = false;
                               this.showRefresh = true;
                               this.getNews(this.selectedLang);
                             }, 10000); // 10 seconds

                    }
                     this.isBusyButton = false;

                } catch (error) {
                    this.isBusyButton = false;
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                }
            },

            /**
             * Search the table data with search input
             */
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
                this.filteredItems = filteredItems;
                this.$nextTick(() => this.ensureReactionTotalsForVisibleRows());
            },

            getVisibleRowsForTotals() {
                const items = Array.isArray(this.filteredItems) ? this.filteredItems : this.tableData;
                const start = (this.currentPage - 1) * this.perPage;
                const end = start + this.perPage;
                return items.slice(start, end);
            },

            async ensureReactionTotalsForVisibleRows() {
                const visibleRows = this.getVisibleRowsForTotals();
                for (const row of visibleRows) {
                    const contentId = row && row.source_id;
                    if (!contentId) continue;
                    if (this.reactionTotals[contentId] !== undefined) continue;
                    if (this.reactionTotalsLoading[contentId]) continue;
                    this.fetchReactionTotal(contentId);
                }
            },

            async fetchReactionTotal(contentId) {
                this.$set(this.reactionTotalsLoading, contentId, true);
                try {
                    const res = await General.getReaction(contentId);
                    const total = res?.data?.data?.summary?.total;
                    this.$set(this.reactionTotals, contentId, typeof total === 'number' ? total : 0);
                } catch (e) {
                    this.$set(this.reactionTotals, contentId, 0);
                } finally {
                    this.$set(this.reactionTotalsLoading, contentId, false);
                }
            },

            async openReactionsModal(row) {
                try {
                    if (this.$refs.reactionsModal && typeof this.$refs.reactionsModal.open === 'function') {
                        await this.$refs.reactionsModal.open(row);
                    }
                } catch (e) {
                    // ignore
                }
            },

        },
        middleware: "authentication",
    };
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="news-feed-toolbar d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
                            <div class="d-flex flex-wrap align-items-center gap-2">
                                <a
                                    v-if="addNewsButton"
                                    href="javascript:void(0);"
                                    class="btn btn-success waves-effect waves-light"
                                    @click="modalAddNews()"
                                >
                                    <i class="mdi mdi-plus me-2"></i>Add News
                                </a>
                            </div>

                            <div class="d-flex flex-wrap align-items-center gap-3">
                                <div
                                    v-if="newsLanguage && newsLanguage.length > 0"
                                    class="d-flex align-items-center gap-2"
                                >
                                    <label class="mb-0 text-muted" for="selectLang">Language</label>
                                    <select
                                        id="selectLang"
                                        v-model="selectedLang"
                                        class="form-select form-select-sm news-feed-lang-select"
                                    >
                                        <option value="">All</option>
                                        <option
                                            v-for="lang in newsLanguage"
                                            :key="lang"
                                            :value="lang"
                                        >
                                            {{ lang.toUpperCase() }}
                                        </option>
                                    </select>
                                </div>

                                <a
                                    v-if="showRefresh && refreshNewsBtn"
                                    href="javascript:void(0);"
                                    class="btn btn-primary waves-effect waves-light"
                                    :class="{ disabled: isBusyButton }"
                                    @click="refreshNews()"
                                >
                                    <span v-if="!isBusyButton">
                                        <i class="mdi mdi-refresh me-2"></i>Refresh News
                                    </span>
                                    <span v-else>
                                        <b-spinner small class="align-middle me-2"></b-spinner>
                                        Loading...
                                    </span>
                                </a>
                            </div>
                        </div>

                        <div
                            v-if="showAlert"
                            class="alert alert-warning py-2 mb-3"
                            role="alert"
                        >
                            Refresh initiated! The pulled news will be available shortly.
                        </div>

                        <div class="row mt-2 mb-4">
                            <div class="col d-inline-flex align-items-center">
                                <h4 class="card-title m-0">Total News: {{ totalRows }}</h4>
                            </div>
                        </div>                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                        id="tickets-table_filter"
                                        class="dataTables_filter text-md-end"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    :busy="isBusy"
                                    :items="tableData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    show-empty
                                    empty-text="No Data Found"
                                    @filtered="onFiltered"
                            >
                                <template v-slot:cell(title)="data">
                                    <div>
                                      <span>{{data.item.title}}</span>
                                      <span  class="badge bg-danger ms-2" style="font-size:12px;"  v-if="data.item.deleted === 1">deleted</span>
                                    </div>
                                </template>
                                <template v-slot:cell(reactions)="data">
                                    <div class="d-flex align-items-center">
                                        <span v-if="reactionTotalsLoading[data.item.source_id]" class="me-2 ">
                                            <b-spinner small class="align-middle"></b-spinner>
                                        </span>
                                        <a href="javascript:void(0);" @click="openReactionsModal(data.item)">
                                            <span v-if="reactionTotals[data.item.source_id] !== undefined">
                                                {{ reactionTotals[data.item.source_id] }}
                                            </span>
                                            <span v-else>View</span>
                                        </a>
                                    </div>
                                </template>
                                <template v-slot:cell(link)="data">
                                    <a :href="data.item.link" target="_blank">{{data.item.link.slice(0, 80)}}...</a>
                                </template>

                                <template v-slot:cell(image)="data">
                                    <div class="flex-shrink-0">
                                        <img class="img-fluid table-images" :src="`${data.item.image}?ts=${Date.now()}`">
                                    </div>
                                </template>

                                <template v-slot:cell(audience_group_id)="data">
                                    {{ getAudienceGroupName(data.item.audience_group_id) }}
                                </template>

                                <template v-slot:cell(action)="data">
                                    <ul class="list-inline mb-0 d-flex align-items-center">
                                        <li v-if="data.item.deleted === 0 && data.item.content_source === 'AZERION'" class="list-inline-item">
                                            <a href="javascript:void(0);" class="text-primary"  title="Edit News" @click="modalEditNews(data.item)">
                                                <i class="uil uil-pen font-size-18"></i>
                                            </a>
                                        </li>
                                        <li v-if="data.item.deleted === 0" class="list-inline-item">
                                            <a href="javascript:void(0);" class=" text-danger" v-b-tooltip.hover title="Remove News" @click="removeNews(data.item.source_id)">
                                                <i class="uil uil-trash-alt font-size-18"></i>
                                            </a>
                                        </li>
                                        <li v-if="data.item.deleted === 1" class="list-inline-item">
                                          <a href="javascript:void(0);" class=" text-danger" v-b-tooltip.hover title="Restore News" @click="restoreNews(data.item.source_id)">
                                            <i class="fas fa-trash-restore-alt font-size-15"></i>
                                          </a>
                                         </li>
                                    </ul>
                                </template>

                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modalReactions ref="reactionsModal" />
        <modalAddNews  @refreshScreen="onRefreshScreen"/>
        <modalEditNews :newsData="selectedNewsItem" @refreshScreen="onRefreshScreen"/>

    </Layout>
</template>

<style scoped>
.news-feed-lang-select {
    width: auto;
    min-width: 7rem;
}
</style>